<template>
  <div class="dem-imp-xml-dados">
    <div class="cabecalho">
      Arquivo: <b v-html="cpntFileName"></b>
    </div>

    <div class="box-geral">
      <!-- APRESENTA A OPÇÃO CARREGANDO NA TELA -->
      <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
      
      <!-- APRESENTA O CONTEUDO DA TELA -->
      <template v-else-if='statusGeral === ""'>
        <div class="box" v-if="[ 'dem_compra', 'dem_venda' ].indexOf(cpntAcao) !== -1">
          <div class="titulo">
            - Dados {{ dadosNF.mod_nome }} [{{ dadosNF.mod }}] 
          </div>

          <div class="conteudo">
            <div class="linha">
              <App-Visualizar-Cadastro-Dados-Template style="width: calc(100% - 900px);"
              :cpntTitulo="'Natureza da Operação'"
              :cpntValor="dadosNF.natOp"
              :cpntCopiar="'dadosNF--' + 'natOp'"
              ></App-Visualizar-Cadastro-Dados-Template>

              <App-Visualizar-Cadastro-Dados-Template style="width: 400px;"
              :cpntTitulo="'Chave Acesso'"
              :cpntValor="dadosNF._chNFe"
              :cpntCopiar="'dadosNF--' + '_chNFe'"
              ></App-Visualizar-Cadastro-Dados-Template>

              <App-Visualizar-Cadastro-Dados-Template style="width: 150px;"
              :cpntTitulo="'Protocolo SEFAZ'"
              :cpntValor="dadosNF.nProt"
              :cpntCopiar="'dadosNF--' + 'nProt'"
              ></App-Visualizar-Cadastro-Dados-Template>

              <App-Visualizar-Cadastro-Dados-Template style="width: 100px;"
              :cpntTitulo="'Número'"
              :cpntValor="dadosNF.nNF"
              :cpntCopiar="'dadosNF--' + 'nNF'"
              ></App-Visualizar-Cadastro-Dados-Template>

              <App-Visualizar-Cadastro-Dados-Template style="width: 100px;"
              :cpntTitulo="'Série'"
              :cpntValor="dadosNF.serie"
              :cpntCopiar="'dadosNF--' + 'serie'"
              ></App-Visualizar-Cadastro-Dados-Template>

              <App-Visualizar-Cadastro-Dados-Template style="width: 150px;"
              :cpntTitulo="'Data/Hora Emissão'"
              :cpntValor="dadosNF._dhEmi"
              :cpntCopiar="'dadosNF--' + '_dhEmi'"
              ></App-Visualizar-Cadastro-Dados-Template>
            </div>
          </div>
        </div>

        <div class="box" v-if="[ 'contato', 'dem_compra', 'dem_venda' ].indexOf(cpntAcao) !== -1 && Object.keys(emitente).length >= 1">
          <div class="titulo">
            - Emitente
          </div>

          <!-- SETA OS DADOS DO CONTATO -->
          <App-Demanda-Importar-Xml-Contato :cpntVetor="emitente"></App-Demanda-Importar-Xml-Contato>
        </div>

        <div class="box" v-if="[ 'contato', 'dem_compra', 'dem_venda' ].indexOf(cpntAcao) !== -1 && Object.keys(destinatario).length >= 1">
          <div class="titulo">
            - Destinatário
          </div>

          <!-- SETA OS DADOS DO CONTATO -->
          <App-Demanda-Importar-Xml-Contato :cpntVetor="destinatario"></App-Demanda-Importar-Xml-Contato>
        </div>

        <div class="box" v-if="[ 'contato', 'dem_compra', 'dem_venda' ].indexOf(cpntAcao) !== -1 && Object.keys(transportadora).length >= 1">
          <div class="titulo">
            - Transportadora
          </div>

          <!-- SETA OS DADOS DO CONTATO -->
          <App-Demanda-Importar-Xml-Contato :cpntVetor="transportadora"></App-Demanda-Importar-Xml-Contato>
        </div>

        <div class="box" v-if="[ 'produto', 'dem_compra', 'dem_venda' ].indexOf(cpntAcao) !== -1">
          <div class="titulo">
            - Produtos
          </div>

          <div class="conteudo">
            <App-Demanda-Importar-Xml-Itens
            :cpntFileConteudo="cpntFileConteudo"
            :cpntPreAnalise="cpntPreAnalise.dem_produto"
            :cpntIndexFile="cpntIndexFile"
            ref="item"
            ></App-Demanda-Importar-Xml-Itens>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.dem-imp-xml-dados {
  margin-top: 30px;
}
  .dem-imp-xml-dados > .cabecalho {
    width: 60%;
    margin: 0px auto;
    text-align: center;
    
    background: #f9f9f9;
    border: 1px solid #e9e9e9;
    padding: 10px 5px 5px 5px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;
  }
  .dem-imp-xml-dados > .box-geral {
    margin: 0px 30px 5px 30px;
    background: #f9f9f9;
  }
  .dem-imp-xml-dados > .box-geral,
  .dem-imp-xml-dados > .box-geral > .box {
    border: 1px solid #e9e9e9;
    padding: 10px;
    border-radius: 10px;
  }
  .dem-imp-xml-dados > .box-geral > .box {
    background: #fff;
    position: relative;
    margin-top: 15px;
  }
  .dem-imp-xml-dados > .box-geral > .box:not(:first-child) {
    margin-top: 30px;
  }

  .dem-imp-xml-dados > .box-geral > .box > .titulo {
    background: #fff;
    border: 1px solid #e9e9e9;
    border-radius: 5px;
    min-width: 135px;
        padding: 1px 10px;
    /* float: left; */
    position: absolute;
    top: -12px;
    font-weight: bold;
  }

  .dem-imp-xml-dados > .box-geral > .box > .conteudo {
    clear: both;
    padding-top: 0px;
  }
    .dem-imp-xml-dados > .box-geral > .box > .conteudo > .linha {
      width: 100%;
      vertical-align: top;
    }
      .dem-imp-xml-dados > .box-geral > .box > .conteudo > .linha > div {
        padding: 2px 4px;
        vertical-align: top;
        display: inline-block;
        width: 100%;
      }
</style>

<script>
// IMPORTA BIBLIOTECA DEPENDENTE
var moment = require('moment')

// IMPORTA A FUNÇÃO UTILIZADA
import { PEGAR_VALOR_CHAVE_XML } from '@/assets/js/Funcoes-Gerais.js'

export default {
  props: {
    cpntAcao: {
      required: true
    },
    cpntFileName: {
      required: true
    },
    cpntIndexFile: {
      required: true
    },
    cpntFileConteudo: {
      required: true
    },
    cpntPreAnalise: {
      required: true
    },
    cpntQRCode: {
      required: true
    },

    cpntTratarTagsContato: {
      required: true
    }
  },
  components: {
    'App-Visualizar-Cadastro-Dados-Template': () => import('@/components/rf-geral/visualizar/Visualizar-Cadastro-Dados-Template.vue'),
    'App-Demanda-Importar-Xml-Contato': () => import('./Demanda-Importar-Xml-Contato'),
    'App-Demanda-Importar-Xml-Itens': () => import('./Demanda-Importar-Xml-Itens')
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      emitente: {},
      destinatario: {},
      transportadora: {},
      dadosNF: {},
      itens: {},
      xml: null,

      infNFe: null,
      tpNF: null,
    }
  },
  mounted: function () {
    this.demImpXmlDadosIniciar()
  },
  methods: {
    demImpXmlDadosIniciar: function () {
      // INICIA A FUNÇÃO DE LEITURA
      var parser = new DOMParser()

      // CARREGA O XML RECEBIDO
      this.xml = parser.parseFromString(this.cpntFileConteudo, 'text/xml')

      // PEGA OS DADOS DA NFE
      this.infNFe = PEGAR_VALOR_CHAVE_XML(this.xml, 'infNFe')

      // PEGA A INFORMAÇÃO SE A NOTA É DE ENTRADA OU SAIDA
      this.tpNF = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'tpNF')
      
      // INICIA A VARIAVEL DE CONTATO
      var emitente = null
      var destinatario = null
      var transportadora = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'transporta')

      // VERIFICA O CADASTRO QUE DEVE UTILIZAR
      switch (this.tpNF) {
        case '0':
          emitente = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'dest')
          destinatario = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'emit')
          break

        case '1':
          emitente = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'emit')
          destinatario = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'dest')
          break
      }

      // SETA OS DADOS DO EMITENTE
      this.emitente = this.cpntTratarTagsContato(emitente)

      // SETA OS DADOS DO EMITENTE
      this.destinatario = this.cpntTratarTagsContato(destinatario)

      // SETA OS DADOS DO EMITENTE
      this.transportadora = this.cpntTratarTagsContato(transportadora)

      // INICIA AS FUNÇÕES DE TRATAMENTO
      this.demImpXmlDadosTratarArquivosDadosNF((_vetor) => {
        // SETA OS VALORES RECEBIDOS
        this.dadosNF = _vetor

        // CARREGA OS ITENS DA COMPRA
        this.itens = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'det')

        // FINALIZA O CARREGAMENTO
        this.demImpXmlDadosSetarStatusGeral('')
      })
    },
    demImpXmlDadosSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    demImpXmlDadosTratarArquivosDadosNF: function (callback) {
      // INICIA A VARIAVEL
      var vetor = {}     

      // CARREGA OS VALORES DAS CHAVE
      vetor.mod       = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'mod')
      vetor.nNF       = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'nNF')
      vetor.serie     = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'serie')
      vetor.natOp     = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'natOp')
      vetor.dhEmi     = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'dhEmi')
      vetor.tpAmb     = PEGAR_VALOR_CHAVE_XML(this.infNFe, 'tpAmb')

      // PEGA OS DADOS DA NFE
      var protNFe = PEGAR_VALOR_CHAVE_XML(this.xml, 'protNFe')

      // CARREGA OS DADOS DO FINAL DO XML
      vetor.chNFe     = PEGAR_VALOR_CHAVE_XML(protNFe, 'chNFe')
      vetor.nProt     = PEGAR_VALOR_CHAVE_XML(protNFe, 'nProt')

      // VERIFICA O TIPO DE NOTA QUE ESTÁ IMPORTANDO
      switch (vetor.mod) {
        case '55':
          vetor.mod_nome = 'NF-e'
          break

        case '65':
          vetor.mod_nome = 'NFC-e'
          break
      }

      // FORMATA A CHAVE DE ACESSO RECEBIDA
      vetor._chNFe = vetor.chNFe.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11')
      
      // FORMATA A DATA E HORA
      vetor._dhEmi = moment(vetor.dhEmi, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY HH:mm:ss')

      // RETORNA O VALOR MONTADO
      callback(vetor)
    },
    // demImpXmlDadosTratarArquivosContato: function (contato, callback) {
    //   // INICIA A VARIAVEL
    //   var vetor = {}
      
    //   // VERIFICAR SE TEM VALOR PARA SER TRATADO
    //   if ([ '', null, undefined ].indexOf(contato) === -1) {
    //     // PEGA A CHAVE DOCUMENTO
    //     var pessoa = contato.getElementsByTagName('CPF').length >= 1 ? 'f' : 'j'
        
    //     // INICIA A VARIAVEL DOCUMENTO
    //     var documento = ''      
  
    //     // VERIFICA O CAMPO QUE DEVE REMOVE PARA CADA TIPO DE CASO
    //     switch (pessoa) {
    //       case 'f':
    //         // PEGA O VALOR DO CAMPO
    //         documento = PEGAR_VALOR_CHAVE_XML(contato, 'CPF')
  
    //         // FORMATA O VALOR RECEBIDO
    //         documento = documento.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    //         break
          
    //       case 'j':
    //         // PEGA O VALOR DO CAMPO
    //         documento = PEGAR_VALOR_CHAVE_XML(contato, 'CNPJ')
  
    //         // FORMATA O VALOR RECEBIDO
    //         documento = documento.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    //         break
    //     }
  
    //     // CONVERTE OS CAMPOS PARA O NOVO VETOR
    //     vetor.nome              = PEGAR_VALOR_CHAVE_XML(contato, 'xNome')
    //     vetor.empresa           = PEGAR_VALOR_CHAVE_XML(contato, 'xFant')
    //     vetor.cnpj_cpf          = documento
    //     vetor.ie                = PEGAR_VALOR_CHAVE_XML(contato, 'IE')
    //     vetor.tel_com           = PEGAR_VALOR_CHAVE_XML(contato, 'fone')
    //     vetor.end               = PEGAR_VALOR_CHAVE_XML(contato, 'xLgr')
    //     vetor.num               = PEGAR_VALOR_CHAVE_XML(contato, 'nro')
    //     vetor.comp              = PEGAR_VALOR_CHAVE_XML(contato, 'xCpl')
    //     vetor.bairro            = PEGAR_VALOR_CHAVE_XML(contato, 'xBairro')
    //     vetor.id_cidade_cidade  = PEGAR_VALOR_CHAVE_XML(contato, 'xMun')
    //     vetor.id_estado         = PEGAR_VALOR_CHAVE_XML(contato, 'UF')
    //     vetor.cep               = PEGAR_VALOR_CHAVE_XML(contato, 'CEP')
    //     vetor.pessoa            = pessoa
  
    //     // PEGA OUTRO CAMPO DE ENDEREÇO
    //     var xEnder = PEGAR_VALOR_CHAVE_XML(contato, 'xEnder')
  
    //     // VERIFICA SE TEM OUTRO CAMPO DE ENDEREÇO
    //     if ([ '', null, undefined ].indexOf(xEnder) === -1 && xEnder.indexOf(',') !== -1) {
    //       // FAZ A SEPARAÇÃO DA STRING
    //       xEnder = xEnder.split(',')
  
    //       // SETA O NUMERO DO ENDEREÇO
    //       vetor.num = xEnder[xEnder.length - 1]
  
    //       // REMOVE A ULTIMA PARTE DA STRING
    //       xEnder = xEnder.splice(xEnder.length - 2, 1)
  
    //       // SETA O NOME DA RUA
    //       vetor.end = xEnder.join(',')
  
    //       // VERIFICA SE AS CHAVES ESTÃO PREENCHIDAS
    //       if ([ '', null, undefined ].indexOf(vetor.cep) !== -1) {
    //         vetor.cep = '-'
    //       }
    //       if ([ '', null, undefined ].indexOf(vetor.num) !== -1) {
    //         vetor.num = '-'
    //       }
    //       if ([ '', null, undefined ].indexOf(vetor.comp) !== -1) {
    //         vetor.comp = '-'
    //       }
    //       if ([ '', null, undefined ].indexOf(vetor.bairro) !== -1) {
    //         vetor.bairro = '-'
    //       }
    //     }
    //   }

    //   // RETORNA O VALOR MONTADO
    //   callback(vetor)
    // }
  },
  watch: {
    cpntFileConteudo: function () {
      this.demImpXmlDadosIniciar()
    }
  }
}
</script>